import { localeRoutes } from "@/pages/[locale]/routes";
import { adminRoutes } from "@/pages/admin/routes";
import { aiRoutes } from "@/pages/ai/routes";
import { audioRecorderRoutes } from "@/pages/audio_recorder/routes";
import { bookmarksRoutes } from "@/pages/bookmarks/routes";
import { collectionsRoutes } from "@/pages/collections/routes";
import { companyRoutes } from "@/pages/company/routes";
import { courseBookmarksRoutes } from "@/pages/course_bookmarks/routes";
import { courseEnrollmentsRoutes } from "@/pages/course_enrollments/routes";
import { coursesRoutes } from "@/pages/courses/routes";
import { curriculumRoutes } from "@/pages/curriculum/routes";
import { fileSharingRoutes } from "@/pages/file_sharing/routes";
import { foldersRoutes } from "@/pages/folders/routes";
import { galleryRoutes } from "@/pages/gallery/routes";
import { helpRoutes } from "@/pages/help/routes";
import { historiesRoutes } from "@/pages/histories/routes";
import { intRoutes } from "@/pages/int/routes";
import { joinRoutes } from "@/pages/join/routes";
import { linkShortenerRoutes } from "@/pages/link_shortener/routes";
import { onboardingRoutes } from "@/pages/onboarding/routes";
import { pRoutes } from "@/pages/p/routes";
import { partnersRoutes } from "@/pages/partners/routes";
import { pinboardRoutes } from "@/pages/pinboard/routes";
import { postsRoutes } from "@/pages/posts/routes";
import { profileRoutes } from "@/pages/profile/routes";
import { pupilFeedbackRoutes } from "@/pages/pupil_feedback/routes";
import { qrcodesRoutes } from "@/pages/qrcodes/routes";
import { salesWizardRoutes } from "@/pages/sales_wizard/routes";
import { schoolClassInvitesRoutes } from "@/pages/school_class_invites/routes";
import { screenRecorderRoutes } from "@/pages/screen_recorder/routes";
import { searchRoutes } from "@/pages/search/routes";
import { sharedFoldersRoutes } from "@/pages/shared-folders/routes";
import { surveysRoutes } from "@/pages/surveys/routes";
import { tRoutes } from "@/pages/t/routes";
import { teachingBoardRoutes } from "@/pages/teaching_board/routes";
import { textEditorRoutes } from "@/pages/text_editor/routes";
import { timetableRoutes } from "@/pages/timetable/routes";
import { videoRecorderRoutes } from "@/pages/video_recorder/routes";
import { websiteRoutes } from "@/pages/website/routes";
import { wordCloudsRoutes } from "@/pages/word_clouds/routes";
import { worksheetRoutes } from "@/pages/worksheet/routes";
import { worksheetWizardRoutes } from "@/pages/worksheet_wizard/routes";
import type { RouteRecordRaw } from "vue-router";

import { rootRoutes } from "./rootRoutes";

export const routes: RouteRecordRaw[] = [
  ...rootRoutes,
  ...adminRoutes,
  ...localeRoutes,
  ...aiRoutes,
  ...audioRecorderRoutes,
  ...bookmarksRoutes,
  ...collectionsRoutes,
  ...companyRoutes,
  ...courseBookmarksRoutes,
  ...courseEnrollmentsRoutes,
  ...coursesRoutes,
  ...curriculumRoutes,
  ...fileSharingRoutes,
  ...foldersRoutes,
  ...galleryRoutes,
  ...helpRoutes,
  ...historiesRoutes,
  ...intRoutes,
  ...joinRoutes,
  ...linkShortenerRoutes,
  ...onboardingRoutes,
  ...pRoutes,
  ...partnersRoutes,
  ...pinboardRoutes,
  ...postsRoutes,
  ...profileRoutes,
  ...pupilFeedbackRoutes,
  ...qrcodesRoutes,
  ...salesWizardRoutes,
  ...schoolClassInvitesRoutes,
  ...screenRecorderRoutes,
  ...searchRoutes,
  ...sharedFoldersRoutes,
  ...surveysRoutes,
  ...tRoutes,
  ...teachingBoardRoutes,
  ...textEditorRoutes,
  ...timetableRoutes,
  ...videoRecorderRoutes,
  ...websiteRoutes,
  ...wordCloudsRoutes,
  ...worksheetWizardRoutes,
  ...worksheetRoutes,
];
